//libraries
import React from "react";

//component
import Listing from "shared/routes/Listing";

//def
import { IListingProps } from "shared/routes/Listing/types";

function Search(props: IListingProps) {
    return <Listing {...props} isSearch />;
}

export default Search;
